import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface GoalsOutstandingTableState {
  data: any;
}

export const GoalsOutstandingTable = ({ data }: GoalsOutstandingTableState): React.JSX.Element | null => {
  const [goalData, setGoalData] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name", width: "300px" },
    { label: "Goal ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Name", key: "subject.name", width: "200px" },
    { label: "Tasks Completed", key: "taskCount", width: "120px" },
    { label: "Created", key: "created_at_formatted", width: "100px" },
  ];

  useEffect(() => {
    if (data) {
      const { goals } = data;
      let outstanding = goals?.filter((g: any) => !g.completed_at);
      outstanding = outstanding?.map((g: any) => {
        return { ...g, taskCount: `${g.completed_tasks}/${g.total_tasks}` };
      });
      setGoalData(outstanding as any[]);
    }
  }, [data]);

  return goalData ? <DataTable tableHeadings={tableHeaders} tableData={goalData} title={"Goals Outstanding"} /> : loadingCard();
};
